// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3KrHP","upload":"Small_upload__2bgtJ","imageWrap":"Small_imageWrap__2TpEr","removeBtn":"Small_removeBtn__2S6MI"};